import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const ImgWithFallback = (props) => {
  const { src, className, issuerConfig } = props;
  const [isFallback, setIsFallback] = useState(false);
  return (
    <img
      alt=""
      className={className}
      src={isFallback ? issuerConfig.favicon : src}
      onError={() => setIsFallback(true)}
    />
  );
};

ImgWithFallback.defaultProps = {
  src: null,
  className: '',
  issuerConfig: {},
};

ImgWithFallback.propTypes = {
  src: PropTypes.string,
  className: PropTypes.string,
  issuerConfig: PropTypes.objectOf(PropTypes.any),
};

const mapStateToProps = (state) => {
  const { issuerConfiguration } = state;
  return {
    issuerConfig: issuerConfiguration.config,
  };
};

export default connect(mapStateToProps, {})(ImgWithFallback);
